<template>
  <v-col cols="12">
    <v-row
      :justify="'space-between'"
      class="mt-3 main-header mb-2 mx-1 font-weight-bold"
    >
      <v-col cols="5" class="pr-0">Store Points</v-col>
      <v-col cols="7" class="pl-0" style="text-align: right">
        <span style="font-weight: normal">My Balance:</span>
        {{ total_points_remaining || 0 }} points
      </v-col>
    </v-row>
    <v-row class="mt-0 pb-1">
      <v-col cols="12" class="header-text"> Available Rewards </v-col>
    </v-row>
    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="click-to-see-rewards pt-0">
        <span v-if="availableRewards().length"
          >Click to see rewards you can redeem right now</span
        >
        <span v-else>No rewards available</span>
      </v-col>
    </v-row>
    <RewardsTabs
      type="points"
      :points="availableRewards()"
      :redeemable="true"
    />
    <v-row class="pb-1">
      <v-col cols="12" class="header-text"> Next Level Rewards </v-col>
    </v-row>
    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="click-to-see-rewards pt-0">
        <span v-if="nextLevelRewards().length"
          >Click to see rewards you can redeem after earning more points</span
        >
        <span v-else>No rewards available</span>
      </v-col>
    </v-row>
    <RewardsTabs type="points" :points="nextLevelRewards()" />
  </v-col>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import RewardsTabs from "../Tabs.vue";
export default {
  name: "XsPoints",
  components: {
    RewardsTabs,
  },
  computed: {
    ...mapGetters("store", {
      total_points_remaining: "total_points_remaining",
      points_offers: "points_offers",
    }),
    ...mapState({
      points: (state) => state.store.info.points,
    }),
  },
  methods: {
    availableRewards() {
      let offers = this.points_offers.filter(
        (x) => x.points <= this.points?.total_points || 0,
      );
      offers.forEach((o) => {
        o.xtra.products.forEach((p) => {
          p.redemption_points_offer_id = o.offering_id;
          p.redemption_points_offer = o.points;
        });
      });
      return offers;
    },
    nextLevelRewards() {
      return this.points_offers.filter((x) => {
        if (this.points?.total_points) {
          return x.points > this.points.total_points;
        } else return true;
      });
    },
  },
};
</script>

<style></style>
